/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import { loc } from "../core/utils"
import React from "react"
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap"

const TooltipContent = ({ document, isParagraphed }) => {
  const Component = isParagraphed ? "p" : React.Fragment

  return (
    <Component>
      {loc(document.description)}
      <OverlayTrigger
        {...(document.tooltip?.position ? { placement: document.tooltip?.position } : {})}
        overlay={<Tooltip>{loc(document.tooltip?.message)}</Tooltip>}
      >
        <span>
          {document.tooltip?.show && (
            <Button className="btn-tooltip" variant="light">
              <i className="fas fa-info-circle" />
            </Button>
          )}
        </span>
      </OverlayTrigger>
    </Component>
  )
}

export default function CustomizedTooltip({ document, isParagraphed }) {
  const Component = isParagraphed ? "div" : React.Fragment

  return (
    <>
      <Component>
        <i className={document.className} />
      </Component>
      <TooltipContent document={document} isParagraphed={isParagraphed} />
    </>
  )
}
